<template>
    <div>
        <Lottery ref="lottery" v-bind="lotteryOptions" :isH5="isH5" :language="language" />
        <DrawResultModal v-model="showDrawResultModal" v-bind="drawResult" />
    </div>
</template>
<script>
/* eslint-disable vue/multi-word-component-names */
import { common, store } from '@futuweb/fego-render';
const { variable } = store;
import { EVENT_NAME, REMAIN_COUNT_PLACEHOLDER } from '../constants/business';
import Lottery from './Lottery/index.vue';
import DrawResultModal from './DrawResultModal/index.vue';
import Toast from '@futuweb/future-ui/es/toast';
import '@futuweb/future-ui/es/toast/style/css';
import { isH5, isLogin } from '../utils';

export default {
    name: 'lottery2',
    props: {
        language: {
            type: String,
            default: ''
        },
        notLoggedText: {
            type: String,
            default: ''
        },
        hasLoggedText: {
            type: String,
            default: ''
        },
        actConfig: {
            type: Array,
            default: () => []
        },
        remainCountName: {
            type: String,
            default: 'commonLotteryRemain'
        },
        currentCountName: {
            type: String,
            default: 'commonLotteryCurrent'
        }
    },
    components: {
        Lottery,
        DrawResultModal
    },
    data() {
        return {
            isH5: isH5(),
            isLogin,
            drawCountInfo: [],
            showDrawResultModal: false,
            drawResult: {
                title: '',
                cover: '',
                desc: '',
                btnLabel: '',
                btnUrl: ''
            }
        };
    },
    computed: {
        // 总抽奖次数
        drawCount() {
            let remain = 0;
            let current = 0;
            this.drawCountInfo.forEach((item) => {
                remain += item.remain;
                current += item.current;
            });
            return {
                current,
                remain
            };
        },
        // 抽奖配置
        lotteryOptions() {
            const remain = this.drawCount.remain;
            let text = this.notLoggedText;
            if (isLogin) {
                text = this.hasLoggedText.replace(REMAIN_COUNT_PLACEHOLDER, this.drawCount.remain);
            }
            return {
                remain,
                text,
                drawCb: async () => {
                    const res = await this.draw();
                    return res;
                },
                drawSuccessCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    if (!res || !res.prizeKey) {
                        throw new Error('request failed');
                    }
                    let app = null;
                    this.actConfig.some((config) => {
                        // 获取中奖的appKey对应的配置
                        app = config.appGroup.find((item) => item.appKey === res.appKey);
                        return app;
                    });
                    const target = app.prizeList.find((item) => item.prizeKey === res.prizeKey) || {};
                    this.drawResult = {
                        title: target.congratTitle || '',
                        cover: target.congratImgUrl || '',
                        desc: target.congratDesc || '',
                        btnLabel: target.congratBtnLabel || '',
                        btnUrl: target.congratBtnUrl || ''
                    };
                    this.showDrawResultModal = true;
                },
                drawFailCb: (err) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    console.log(err);
                    Toast.error('The request failed, please refresh and try again');
                },
                noRemainCb: () => {
                    this.$emit(EVENT_NAME.NO_REMAIN);
                },
                noLoginCb: () => {
                    this.$emit(EVENT_NAME.NO_LOGIN);
                }
            };
        }
    },
    watch: {
        drawCount: {
            handler(newValue) {
                // 透出fego变量
                const currentName = this.currentCountName;
                const remainName = this.remainCountName;
                variable.data[currentName] = newValue.current;
                variable.data[remainName] = newValue.remain;
            },
            deep: true // 开启深度监听
        }
    },
    mounted() {
        if (window.FEGORender && isLogin) {
            this.getDrawCount();
        }
    },
    methods: {
        async getDrawCount() {
            const params = [];
            this.actConfig.forEach((config) => {
                config.appGroup.forEach((item) => {
                    params.push({
                        act_sign: config.actSign,
                        app_key: item.appKey,
                        group: item.group
                    });
                });
            });
            if (!params.length) {
                return;
            }

            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery2');
            const loading = Toast.loading({
                duration: 0
            });
            try {
                this.drawCountInfo = await commonApiLottery.post(
                    'drawCountInfo',
                    {
                        draw_configs: params
                    },
                    {
                        group: null // 不需要限制请求频次
                    }
                );
                loading.hide();
            } catch (error) {
                loading.hide();
                throw error;
            }
        },
        async draw() {
            const draw_configs = [];
            this.actConfig.forEach((config) => {
                config.appGroup.forEach((item) => {
                    draw_configs.push({
                        act_sign_encode: config.actSignEncode,
                        app_key_encode: item.appKeyEncode,
                        group_encode: item.groupEncode
                    });
                });
            });
            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery2');

            const loading = Toast.loading({
                duration: 0
            });
            try {
                const res = await commonApiLottery.post('draw', {
                    draw_configs,
                    delay: this.delay
                });
                loading.hide();
                return res;
            } catch (error) {
                loading.hide();
                throw error;
            }
        },

        /**
         * 供交互配置使用
         */
        lotteryDraw() {
            this.$refs.lottery.draw();
        }
    }
};
</script>
<style lang="less" scoped></style>
